export default __webpack_public_path__ + "static/media/hero-bg2.1853823c.jpg";